import { render } from "./App.vue?vue&type=template&id=1d21f2a5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1d21f2a5&lang=scss"

import exportComponent from "C:\\Users\\sebamoh\\WebstormProjects\\qrscanner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__